import React from 'react';
import { dynastyTheme } from '../../../services/colorService';

const C = dynastyTheme.tokens.colors;

const StandingsDateStepper = ({ currentDate, availableDates, onDateChange }) => {
  if (!availableDates || availableDates.length === 0) return null;

  const currentIdx = availableDates.indexOf(currentDate);
  const hasPrev = currentIdx > 0;
  const hasNext = currentIdx < availableDates.length - 1;

  const formatted = currentDate
    ? new Date(currentDate + 'T00:00:00').toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
    : '';

  return (
    <div style={styles.container}>
      <button
        style={{ ...styles.arrow, opacity: hasPrev ? 1 : 0.3 }}
        disabled={!hasPrev}
        onClick={() => hasPrev && onDateChange(availableDates[currentIdx - 1])}
      >
        ◄
      </button>
      <span style={styles.dateText}>{formatted}</span>
      <button
        style={{ ...styles.arrow, opacity: hasNext ? 1 : 0.3 }}
        disabled={!hasNext}
        onClick={() => hasNext && onDateChange(availableDates[currentIdx + 1])}
      >
        ►
      </button>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  },
  arrow: {
    background: 'none',
    border: 'none',
    color: C.mutedLight,
    fontSize: '12px',
    cursor: 'pointer',
    padding: '2px 4px',
    lineHeight: 1,
  },
  dateText: {
    fontSize: '12px',
    color: C.textHi,
    fontWeight: 500,
    whiteSpace: 'nowrap',
  },
};

export default StandingsDateStepper;
